import { render, staticRenderFns } from "./importRegisteredStudents.vue?vue&type=template&id=0fa46987&scoped=true"
import script from "./importRegisteredStudents.vue?vue&type=script&lang=js"
export * from "./importRegisteredStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa46987",
  null
  
)

export default component.exports